import dynamic from "next/dynamic";
import dateFormat from "date-fns/format";
import { DateFormats } from "./date";

const ClaimIcon = dynamic<any>(() => import("@public/images/claim.svg"), {
  ssr: true
});
const PolicyIcon = dynamic<any>(() => import("@public/images/policy.svg"), {
  ssr: true
});
const RenewIcon = dynamic<any>(() => import("@public/images/renew.svg"), {
  ssr: true
});
const EditIcon = dynamic<any>(() => import("@public/images/edit.svg"), {
  ssr: true
});

export const PLAN_MAPPING = {
  car_comprehensive: "COMPREHENSIVE PLAN", // eslint-disable-line
  bike_comprehensive: "COMPREHENSIVE PLAN", // eslint-disable-line
  bike_tp: "THIRD PARTY PLAN", // eslint-disable-line
  car_tp: "THIRD PARTY PLAN", // eslint-disable-line
  bike_bundled: "BUNDLED PLAN", // eslint-disable-line
  car_bundled: "BUNDLED PLAN", // eslint-disable-line
  zero_depreciation_car: "ZERO DEPRECIATION CAR" // eslint-disable-line
};

export const SMALL_CASE_PLAN_MAPPING = {
  car_comprehensive: "Comprehensive", // eslint-disable-line
  zero_depreciation_car: "Zero Dep Policy" // eslint-disable-line
};

export const odExpiryDateStart = new Date(
  dateFormat(new Date("Jan 01 2019"), DateFormats.FULL_DATE)
);

export const ppedDateStart = new Date(
  dateFormat(new Date("Jan 01 2000"), DateFormats.FULL_DATE)
);

export const INSPECTION_STATUS = {
  INSPECTION_SURVEY_PENDING: "SCHEDULED",
  INSPECTION_RESCHEDULED: "SCHEDULED",
  INSPECTION_SCHEDULE_PENDING: "SCHEDULE PENDING",
  INSPECTION_ASSESSMENT_PENDING: "PROCESSING",
  INSPECTION_EXPIRED: "EXPIRED",
  INSPECTION_CANCELLED: "CANCELLED",
  INSPECTION_APPROVED: "APPROVED",
  INSPECTION_APPROVED_WITH_EXCLUSIONS: "APPROVED",
  INSPECTION_REJECTED: "REJECTED",
  PENDING_PAYMENT: "PENDING"
};

export const MAKE_CLAIM = "Make a Claim";
export const DOWNLOAD_POLICY = "Download Policy";
export const RENEW_ACKO_POLICY = "Renew Acko Policy";
export const EDIT_POLCY = "Edit Policy";

export const quickLinksData = [
  {
    icon: ClaimIcon,
    text: "Make a Claim",
    link: "",
    key: MAKE_CLAIM
  },
  {
    icon: PolicyIcon,
    text: "Download Policy",
    link: "",
    key: DOWNLOAD_POLICY
  },
  {
    icon: RenewIcon,
    text: "Renew Acko Policy",
    link: "",
    key: RENEW_ACKO_POLICY
  },
  {
    icon: EditIcon,
    text: "Edit Policy",
    link: "",
    key: EDIT_POLCY
  }
];

export const proposalDataMapping = {
  is_commercial: "carType", // eslint-disable-line
  variant_id: "variantId", // eslint-disable-line
  registration_number: "carNumber", // eslint-disable-line
  mobile_no: "mobileNumber", // eslint-disable-line
  pincode: "pinCode", // eslint-disable-line
  purchase_year: "registrationYear", // eslint-disable-line
  purchase_month: "registrationMonth", // eslint-disable-line
  last_claim_year: "lastClaimYear", // eslint-disable-line
  previous_policy_status: "policyStatus", // eslint-disable-line
  policy_expiry: "expiry", // eslint-disable-line
  external_cngkit: "externalCNGKit", // eslint-disable-line
  external_cng_kit_amount: "externalCNGKitAmount", // eslint-disable-line
  plan_type: "planType", // eslint-disable-line
  plan_id: "planId",
  idv: "idv",
  mobile_verified: "mobileVerified",
  quotes_count: "quotesCount",
  ncb: "ncb",
  rc_data_populated: "rcDataPopulated",
  full_name: "fullName",
  email_id: "emailId",
  pped_source: "ppedSource",
  pped_min_range: "previous_policy_expiry_date_min",
  pped_max_range: "previous_policy_expiry_date_max",
  previous_policy_expiry_date: "previous_policy_expiry_date",
  car_name: "carName",
  make: "make",
  model: "model",
  variant: "variant",
  cc: "cc",
  fuel_type: "fuelType",
  model_image_source: "modelImage",
  last_page: "last_page",
  check_od_only: "check_od_only",
  own_damage_pped: "own_damage_pped",
  third_party_pped: "third_party_pped",
  tp_expiry_date: "tp_expiry_date",
  is_corporate: "isCorporate",
  previous_policy_type: "previousPolicyType",
  enable_commercial: "enable_commercial",
  disable_previous_tp_policy: "disable_previous_tp_policy",
  disable_policy_expired: "disable_policy_expired",
  total_amount: "total_amount",
  policy_name: "policy_name",
  dob: "dob",
  ls_push: "ls_push",
  rtoCode: "rtoCode",
  engine_number: "engine_number",
  chassis_number: "chassis_number",
  engine_number_unmasked: "engine_number_unmasked",
  chassis_number_unmasked: "chassis_number_unmasked",
  nominee: "nominee",
  nomineeRelation: "nomineeRelation",
  nomineeAge: "nomineeAge",
  gstin: "gstin",
  loanProvider: "loanProvider",
  is_financed: "is_financed",
  selected_idv_type: "selected_idv_type",
  planDisplayName: "planDisplayName",
  rto: "rto",
  tentativePurchaseDate: "tentativePurchaseDate",
  invoiceConsentDate: "invoiceConsentDate",
  source: "source",
  isNomineeEligible: "isNomineeEligible",
  pi_required: "pi_required",
  isPAIncluded: "isPAIncluded",
  previousInsurer: "previousInsurer",
  policyStartTime: "policyStartTime",
  policyNumber: "policyNumber",
  isBike: "isBike",
  paymentDisabled: "paymentDisabled",
  date_of_birth: "dateOfBirth",
  registration_year: "registrationYear",
  registration_month: "registrationMonth",
  variant_ekey: "variantId",
  is_external_cng_kit: "externalCNGKit",
  is_renewal: "isRenewal",
  net_premium: "previousPolicyNetPremium",
  plan: "previousPolicyId",
  detailed_plan: "previousPolicyPlanId",
  proposal_status: "proposalStatus",
  created_by_advisor: "createdByAdvisor",
  masked_name: "masked_name",
  masked_email: "masked_email",
  masked_phone: "masked_phone",
  order_id: "order_id",
  order_date: "order_date",
  fastagAmount: "fastagAmount" 
};

export const cardDetailsParams = [
  "carNumber",
  "mmv",
  "expiry",
  "pinCode",
  "registrationYear",
  "registrationMonth",
  "ncb",
  "policyStatus"
];

export const carDetailsCardV2Params = [
  "carNumber",
  "mmv",
  "registrationMonth",
  // "registrationYear",
  "pinCode",
  "expiry",
  "policyStatus",
  "ncb"
];

export const carDetailsCardV2PlansParams = [
  "carNumber",
  "mmv",
  // "registrationMonth",
  // "registrationYear",
  // "pinCode",
  // "expiry",
  // "policyStatus",
  "ncb"
];

// Will tell on which page the vehicle summary card to be disabled
export const disableCompactCarDetail = [
  // "previous-policy-type",
  // "date-of-birth",
  // "last-policy-claim",
  // "expiry",
  // "expiry-dates",
  // "policy-status",
  // "tentative-purchase-date",
  // "your-car"
];

export const newCardDetailsParams = [
  "carNumber",
  "mmv",
  "expiry",
  "pinCode",
  "rto",
  // "registrationYear",
  // "registrationMonth",
  "policyStatus",
  // "carType",
  "rtoCode"
];

export const carDetailsModify = [
  "carNumber",
  "mmv",
  "expiry",
  "policyStatus",
  "carType",
  "pinCode",
  "rto",
  "registrationYear",
  "registrationMonth",
  "ncb",
  "own_damage_pped",
  "third_party_pped",
  "previousPolicyType",
  "dob",
  "fuelType",
  "planName"
];

export const carDetailsModifyInPlanScreen = [
  "carNumber",
  "mmv",
  "variant",
  "pped",
  // "carType",
  "policyStatus",
  "lastPolicyClaim",
  "pinCode",
  "registrationYear",
  "registrationMonth",
  "previousNcb",
  "own_damage_pped",
  "third_party_pped",
  "previousPolicyType",
  "dob",
  "fuelType"
];

export const carDetailsModifyInPlanScreenEditTypeName = {
  carNumber: "Car number",
  mmv: "Make and model",
  variant: "Variant",
  pped: "Policy expiry date",
  // carType: "Car type",
  policyStatus: "Policy status",
  lastPolicyClaim: "Claimed in previous policy",
  pinCode: "Pincode",
  registrationYear: "Registration year",
  registrationMonth: "Registration month",
  previousNcb: "Previous policy NCB",
  own_damage_pped: "Own damage expiry date",
  third_party_pped: "Third party expiry date",
  previousPolicyType: "Previous policy type",
  dob: "Date of birth",
  fuelType: "Fuel type"
};

export const newCarDetailsModifyInPlanScreen = [
  "carNumber",
  "mmv",
  "variant",
  "pped",
  "carType",
  "policyStatus",
  "pinCode",
  "rto",
  "registrationYear",
  "registrationMonth",
  "ncb",
  "own_damage_pped",
  "third_party_pped",
  "previousPolicyType",
  "dob",
  "fuelType"
];

export const newCarDetailsModifyInPlanScreenEditTypeName = {
  carNumber: "Car number",
  mmv: "Make and model",
  variant: "Variant",
  pped: "Policy expiry date",
  carType: "Car type",
  policyStatus: "Policy status",
  pinCode: "Pin code",
  rto: "RTO",
  registrationYear: "Registration year",
  registrationMonth: "Registration month",
  previousNcb: "Previous policy NCB",
  own_damage_pped: "Own damage expiry date",
  third_party_pped: "Third-party expiry date",
  previousPolicyType: "Previous policy type",
  dob: "Date of birth",
  fuelType: "Fuel type"
};

export const carDetailsModifyInJourney = [
  "carNumber",
  "mmv",
  "expiry",
  "carType",
  "policyStatus",
  "pinCode",
  "registrationYear",
  "registrationMonth",
  "ncb",
  "own_damage_pped",
  "third_party_pped",
  "previousPolicyType"
];

export const newCarDetailsModifyInJourney = [
  "mmv",
  "expiry",
  // "carType",
  "policyStatus",
  "pinCode",
  "rto"
  // "registrationYear",
  // "registrationMonth"
];

export const proposalSummaryMapping = {
  policy_name: "policyName",
  cover_premium: "coverPremium",
  additional_discount: "additionalDiscount",
  discounts_applied: "discountsApplied",
  addons: "addons",
  net_premium: "netPremium",
  gst: "gst",
  total_amount: "totalAmount",
  offer_details: "offerDetails",
  renewal_date: "renewalDate"
};

export const analyticsDataMapping = {
  fullName: "name",
  emailId: "email",
  carNumber: "registration_number",
  carType: "vehicle_type",
  pinCode: "pincode",
  mobileNumber: "phone",
  ppedSource: "previous_policy_expiry_date_source",
  policyStatus: "previous_policy_status",
  expiry: "previous_policy_expired",
  pped: "previous_policy_expiry_date",
  registrationYear: "registration_year",
  registrationMonth: "registration_month",
  lastPolicyClaim: "last_claim_year",
  externalCNGKit: "is_external_cng",
  idv: "selected_idv",
  planType: "plan_type",
  make: "make",
  variant: "vehicle_variant",
  model: "model",
  fuelType: "fuel_type",
  tpPpedSource: "third_party_policy_expiry_date_source",
  odPpedSource: "own_damage_policy_expiry_date_source",
  previousPolicyType: "previous_policy_type",
  previousPolicyTypeTpYear: "previous_policy_type_tp_year",
  selectedAddons: "selectedAddons"
};

export const proposalErrorMessageMappings = {
  pincodeError: "Pincode Not Servicable"
};

export const IdvOPTIONS = { f: "minimum", r: "maximum", c: "custom" };

export const ErrorMapping = {
  NOT_SERVICEABLE_PINCODE: "Pincode Not Servicable"
};

export const tagTheme = {
  "Most Popular": {
    color: "#00a871",
    backgroundColor: "#e4f9e5"
  },
  "Not Recommended": {
    color: "#E50031",
    backgroundColor: "#FFE9EE"
  }
};

export const trackShowNameEkind = [
  "razorpay_payment_screen_loaded",
  "razorpay_modal_opened",
  "checkout_submitted_buy_now",
  "pay_now_clicked_review",
  "whatsApp_optin",
  "coupon_code_tap_to_apply",
  "coupon_code_removed",
  "view_premium_breakup_clicked",
  "whatsApp_optout",
  "resend_otp",
  "send_otp_clicked",
  "verify_otp_clicked",
  "recommended_coupon_loaded"
];
